export const outer = {
  width: '100%',
  height: '100%',
  paddingTop: 14,
  overflow: 'hidden' as const,
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  display: 'flex',
  flex: 1,
};

export const outerStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  minHeight: '100vh',
  alignItems: 'center',
  justifyContent: 'center',
  margin: 0,
  padding: 0,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 0,
};

export const leftColumn = {
  flex: '1 1 0',
  flexDirection: 'column' as const,
  justifyContent: 'flex-start',
  alignItems: 'center',
  display: 'flex',
};
export const storeHeader = {
  width: '100%',
  height: '100%',
  flexDirection: 'column' as const,
  justifyContent: 'center',
  alignItems: 'center',
  gap: 24,
  display: 'inline-flex',
};

export const storeHeaderTitle = {
  color: '#2E2E2E',
  fontSize: 24,
  margin: '2dvh auto 4.5dvh auto',
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 500,
  textTransform: 'capitalize' as const,
  wordWrap: 'break-word'
}

export const cardsWrap = {
  alignSelf: 'stretch',
  paddingTop: 32,
  paddingBottom: 40,
  paddingLeft: 24,
  paddingRight: 24,
  background: 'url("https://rescloud.ediblearrangements.com/image/upload/v1745436628/Creative-Marketing/site_support/banners/hero/5.5_Desktop_mday-v2.webp") center/cover no-repeat',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: 32,
  display: 'flex',
  flexWrap: 'nowrap' as const,
  overflowX: 'scroll' as const,
  overflowY: 'hidden' as const,
  width: '100%',
  maxWidth: '100vw',
  minWidth: 0,
};

export const cardsWrapGrid = {
  alignSelf: 'stretch',
  paddingTop: 32,
  paddingBottom: 40,
  paddingLeft: 0,
  paddingRight: 24,
  background: 'url("https://rescloud.ediblearrangements.com/image/upload/v1745436628/Creative-Marketing/site_support/banners/hero/5.5_Desktop_mday-v2.webp") center/cover no-repeat',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: 32,
  display: 'inline-flex',
  flexWrap: 'wrap' as const,
  alignContent: 'flex-start',
  minHeight: 240,
};

export const comingSoonTitle: React.CSSProperties = {
  color: '#2E2E2E',
  fontSize: 24,
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 500,
  textTransform: 'capitalize' as const,
  wordWrap: 'break-word' as const,
  padding: '32px 24px 5px',
  alignSelf: 'flex-start',
  margin: 'auto 20px',
};

export const card: React.CSSProperties = {
  width: 240,
  height: 216,
  background: 'white',
  boxShadow: '0px 7px 15px rgba(0, 0, 0, 0.16)',
  borderRadius: 8,
  justifyContent: 'center',
  alignItems: 'center',
  gap: 32,
  display: 'flex',
  flex: '0 0 auto',
  flexDirection: 'column' as const,
};

export const cardInner = {
  paddingLeft: 24,
  paddingRight: 24,
  paddingTop: 32,
  paddingBottom: 32,
  alignSelf: 'stretch',
  flexDirection: 'column' as const,
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: 12,
  display: 'flex',
};

export const cardImage = {
  alignSelf: 'stretch',
  height: 131,
  padding: 124.5,
  borderRadius: 5,
  objectFit: 'cover' as const,
};

export const cardTitleWrap: React.CSSProperties = {
  alignSelf: 'stretch',
  flexDirection: 'column' as const,
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: 8,
  display: 'flex',
  textAlign: 'center'
};

export const cardTitle = {
  color: 'black',
  fontSize: 18,
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 500,
  textTransform: 'capitalize' as const,
  wordWrap: 'break-word' as const,
};
